<template>
    
</template>

<script>

    import {Metadata, Template, Parameter, Instance, OP, DATUM, Operators, Table, Field, Enum, i18n} from '../../mould';

    export default {

        name: 'Test3',

        data(){
            return {

            }
        },

        mounted(){
            this.case1();
            // this.case2();
        },

        methods: {


            case1(){

                const temps = [

                    // new Template('+', 'mysql', '$1+$2', '$1+$2', 'number', {
                    //     $1: new Parameter('number'),
                    //     $2: new Parameter('number')
                    // }).as('?'),

                ];

                // let inst_1 = new Instance({template: OP('>')});
                // inst_1.setValue('$1', 2);
                // inst_1.setValue('$2', 80);
                //
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                // let inst_2 = new Instance({template: OP('+')});
                // inst_2.setValue('$1', 3);
                // inst_2.setValue('$2', 4);
                // inst_1.setValue('$2', inst_2);
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                // inst_1.setValue('$2', 'w');
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                // inst_1.setValue('$2', Metadata.fieldsList()[0]);
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                // inst_1.setValue('$2', Metadata.fieldsList()[2]);
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                // inst_1.setValue('$2', Metadata.fieldsList()[3].getEnums()[0]);
                // console.log(inst_1.outputText('display'), inst_1.isLegitimate());
                //
                //
                // let inst_3 = new Instance({template: OP('concat')});
                // inst_3.setValue('$1', 1);
                // inst_3.setValue('$2', 'w');
                // console.log(inst_3.outputText());
                //
                //
                //
                // console.log((1).resops());
                // console.log('w'.resops());
                // console.log(Metadata.fieldsList()[0].resops())
                // console.log(inst_3.resops());
                // console.log(Metadata.fieldsList()[3].getEnums()[0].resops())



                // new Template('+', 'java', '$1+$2', '$1+$2', 'number', {
                //     $1: new Parameter('number'),
                //     $2: new Parameter('number')
                // }).as('+');
                // Operators.activateContext('java');
                // console.log(OP('+'))


                Metadata.useExample()

                console.log(DATUM('PERSON_INFO', 'GENDER', 0))
            },


            case2(){


                i18n.switchTo('cn');
                Operators.activateContext('mysql-cn');

                let allData = [
                    new Table({
                        name: 'USER_INFO_DIM',
                        label: '用户信息维表'
                    }).addFields([
                        new Field({
                            name: 'USER_ID',
                            label: '用户ID',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'USER_NAME',
                            label: '用户名称',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'AGE',
                            label: '年龄',
                            dataType: 'number',
                            distributeType: 'metrics',
                            unit: '岁'
                        }),
                        new Field({
                            name: 'GENDER',
                            label: '性别',
                            dataType: 'number',
                            distributeType: 'category',
                        }).addEnums([
                            new Enum({
                                code: 0,
                                label: '男'
                            }),
                            new Enum({
                                code: 1,
                                label: '女'
                            })
                        ])
                    ]),

                    new Table({
                        name: 'COMMODITY_INFO_DIM',
                        label: '商品信息维表'
                    }).addFields([
                        new Field({
                            name: 'COMMODITY_ID',
                            label: '商品ID',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'COMMODITY_NAME',
                            label: '商品名称',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'UNIT_PRICE',
                            label: '单价',
                            dataType: 'number',
                            distributeType: 'metrics',
                            unit: '元'
                        }),
                    ]),

                    new Table({
                        name: 'COMMODITY_PURCHASE_LOG',
                        label: '商品购买记录表'
                    }).addFields([
                        new Field({
                            name: 'COMMODITY_ID',
                            label: '商品ID(禁用)',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'USER_ID',
                            label: '用户ID(禁用)',
                            dataType: 'string'
                        }),
                        new Field({
                            name: 'QUANTITY',
                            label: '交易数量',
                            dataType: 'number',
                            distributeType: 'metrics',
                            unit: '个'
                        }),
                        new Field({
                            name: 'DISCOUNT',
                            label: '折扣',
                            dataType: 'string',
                            distributeType: 'category',
                        }).addEnums([
                            new Enum({
                                code: 'none',
                                label: '无折扣'
                            }),
                            new Enum({
                                code: '0.8-all',
                                label: '总价8折'
                            }),
                            new Enum({
                                code: '0.5-sec',
                                label: '第2个半价'
                            }),
                            new Enum({
                                code: 'free',
                                label: '白给'
                            })
                        ])
                    ])
                ];

            }

        }
    }
</script>

<style scoped>

</style>